module.exports = __webpack_public_path__ + "static/media/joinusFood4.638b5805.jpg";